export default __webpack_public_path__ + "static/media/bg-app-2.eaf78fef.jpg";